// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import Swiper from 'swiper/js/swiper';

const fragments = {
  SWIPER: '[data-fragment="LandingShowcase.swiper"]',
  PREV: '[data-fragment="LandingShowcase.prev"]',
  NEXT: '[data-fragment="LandingShowcase.next"]',
  POINT: '[data-fragment="LandingShowcase.point"]',
  POINT_TRIGGER: '[data-fragment="LandingShowcase.pointTrigger"]',
  POPUP_CLOSE: '[data-fragment="LandingShowcase.popupClose"]',
  POPUP: '[data-fragment="LandingShowcase.popup"]'
};

export default class LandingShowcase extends WebComponent {
  constructor (props) {
    super(props);

    this.state = {
      popupActive: false,
      activePopup: null
    };
    this.togglePopup = this.togglePopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.initPopups = this.initPopups.bind(this);
  }

  didMount() {
    this.swiperEl = this.element.querySelector(fragments.SWIPER);
    this.swiper = new Swiper(this.swiperEl, {
      navigation: {
        nextEl: fragments.NEXT,
        prevEl: fragments.PREV,
      },
      on: {
        transitionEnd: this.initPopups
      }
    });
    this.on('click', fragments.POINT_TRIGGER, this.togglePopup);
    this.on('click', fragments.POPUP_CLOSE, this.closePopup);
    window.addEventListener('resize', this.initPopups);
    this.points = this.element.querySelectorAll(fragments.POINT);
    this.popups = this.element.querySelectorAll(fragments.POPUP);
    this.initPopups();
  }

  initPopups = () => {
    for (let i = 0; i < this.points.length; i++) {
      this.points[i].classList.remove('landing-showcase__point--left');
      this.points[i].classList.remove('landing-showcase__point--top');
      let popupWidth = this.popups[i].offsetWidth;
      let popupHeight = this.popups[i].offsetHeight;
      let freeSpaceRight = this.swiperEl.offsetWidth - (this.points[i].getBoundingClientRect().right - ((this.element.offsetWidth - this.swiperEl.offsetWidth) / 2));
      let freeSpaceBottom = this.swiperEl.offsetHeight - this.points[i].offsetTop;
      if (freeSpaceRight < popupWidth) {
        this.points[i].classList.add('landing-showcase__point--left');
      }
      if (freeSpaceBottom < popupHeight) {
        this.points[i].classList.add('landing-showcase__point--top');
      }
    }
  };

  togglePopup = (e) => {
    if (window.innerWidth < 992) {
      if (!this.state.activePopup) {
        this.setState({
          popupActive: true,
          activePopup: e.target.offsetParent
        });
      }
    } else {
      const { popupActive } = this.state;
      this.setState({
        popupActive: !popupActive
      });
      if (this.state.activePopup) {
        this.setState({
          activePopup: null
        });
      } else {
        this.setState({
          activePopup: e.target.offsetParent
        });
      }
    }
  };

  closePopup = (e) => {
    this.setState({
      popupActive: false,
      activePopup: null
    });
  };

  willUnMount() {

  }
  update() {
    const { popupActive, activePopup } = this.state;
    for (let i = 0; i < this.points.length; i++) {
      this.points[i].classList.remove('landing-showcase__point--active');
    }
    if (activePopup) {
      classNames(activePopup, { 'landing-showcase__point--active': true });
    }
    classNames(this.element, { 'landing-showcase--popup-active': popupActive });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/LandingShowcase.js